import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startSpan } from './OpenTelemetryProvider';

function PageTracking({ children }) {
  const location = useLocation();

  useEffect(() => {
    const openSpan = startSpan('Open page');
    openSpan.setAttribute('Page', location.pathname);
    openSpan.setAttribute('Search', location?.search);
    openSpan.end();
    const closeSpan = startSpan('Close page');
    closeSpan.setAttribute('Page', location.pathname);
    closeSpan.setAttribute('Search', location?.search);
    return () => {
      closeSpan.end();
    };
  }, [location]);

  return [children];
}

export default PageTracking;
